// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/account_management/bank_switch/firstparty/v1/get_movable_payment.proto

/* oxlint-disable */
import { ApiMovablePayment } from "./movable_payment";

/** Request to fetch a single movable payment by its identifier. */
export interface ApiGetMovablePaymentRequest {
  /** Unique identifier of the movable payment (from path parameter). */
  readonly id: string;
}

/** Response containing the requested movable payment. */
export interface ApiGetMovablePaymentResponse {
  /** The requested movable payment. */
  readonly movablePayment: ApiMovablePayment | null;
}

export const ApiGetMovablePaymentRequest: MessageFns<ApiGetMovablePaymentRequest> = {
  fromJSON(object: any): ApiGetMovablePaymentRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: ApiGetMovablePaymentRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    return obj;
  },
};

export const ApiGetMovablePaymentResponse: MessageFns<ApiGetMovablePaymentResponse> = {
  fromJSON(object: any): ApiGetMovablePaymentResponse {
    return {
      movablePayment: isSet(object.movable_payment) ? ApiMovablePayment.fromJSON(object.movable_payment) : null,
    };
  },

  toJSON(message: ApiGetMovablePaymentResponse): unknown {
    const obj: any = {};
    if (message.movablePayment !== undefined && message.movablePayment !== null) {
      obj.movable_payment = ApiMovablePayment.toJSON(message.movablePayment);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
